import log from '~/utils/log';

export default defineNuxtPlugin(() => {
    const runtimeConfig = useRuntimeConfig();
    // Currently disabled because it's not in use and also broken
    if (runtimeConfig.public.disableSalesforceInteractions) return;

    const hasSalesforceConsent = ref(false);
    const salesforceConsent = useUsercentricsConsentItem('salesforce_interactions');

    const createSalesforceConsent = (status: 'OptIn' | 'OptOut') => {
        const salesforceInteractions = window.SalesforceInteractions;

        return {
            provider: 'Usercentrics',
            purpose: salesforceInteractions?.ConsentPurpose?.Tracking ?? 'Tracking',
            status: salesforceInteractions?.ConsentStatus?.[status] ?? status
        };
    };

    const updateSalesforceConsent = (status: 'OptIn' | 'OptOut') => {
        try {
            Promise.resolve(window.SalesforceInteractions?.updateConsents?.([createSalesforceConsent(status)])).catch(
                () => {}
            );
        } catch {
            return;
        }
    };

    const applyConsent = () => {
        const hasConsent = salesforceConsent.value === true;

        if (!hasConsent && hasSalesforceConsent.value) {
            updateSalesforceConsent('OptOut');
        }

        hasSalesforceConsent.value = hasConsent;
    };

    const head = computed(() => {
        if (!hasSalesforceConsent.value) return {};

        return {
            script: [
                {
                    key: 'salesforce_interactions',
                    // Make sure to update the Content Security Policy in nuxt.config.ts when changing the URL here
                    src: 'https://cdn.c360a.salesforce.com/beacon/c360a/2d159a0a-b61a-4bb2-82b5-872d8f9b3972/scripts/c360a.min.js',
                    defer: true,
                    onload() {
                        window.SalesforceInteractions?.init({
                            consents: [createSalesforceConsent('OptIn')]
                        });
                    }
                }
            ]
        };
    });

    refreshUsercentricsConsentCache()
        .then(applyConsent)
        .catch((error) => {
            log.warn('Failed to refresh Usercentrics consent state', error);
        });
    useHead(head);

    onConsentUpdated(applyConsent);
});
